import React from 'react';

import { TextField, IconButton } from 'e100-react-components';
import { Icon } from 'components';

import { useFilterContext } from '../../../../context';
import { useIntl } from 'react-intl';
import { useStyles } from './styles';

import { STATIONS_AMPLITUDE_EVENTS } from 'entities/stations';

import { logAmplitudeEvent } from 'shared/utils/amplitude/amplitude';
import { useDebounce } from 'shared/hooks';

export const Search = () => {
  const {
    searchString,
    changeSearchString,
    resetSearchString
  } = useFilterContext();
  const { formatMessage } = useIntl();
  const classes = useStyles();

  useDebounce(() => {
    if (searchString.trim().length) {
      logAmplitudeEvent(
        STATIONS_AMPLITUDE_EVENTS.searchFavouriteServicePoints,
        { extra: { searchStr: searchString } }
      );
    }
  }, 500, [searchString])

  return (
    <div className={classes.root}>
      <TextField
        value={searchString}
        onChange={changeSearchString}
        fullWidth
        placeholder={formatMessage({ id: 'searchByLists' })}
        InputProps={{
          endAdornment: !!searchString ? <IconButton
            kind={'close'}
            color={'default'}
            classes={{
              button: {
                root: classes.iconButtonRoot
              }
            }}
            onClick={resetSearchString}
          /> : null
        }}
        classes={{
          root: classes.textFieldRoot
        }}
      />
      <Icon
        kind="search"
        classes={{
          root: classes.iconRoot
        }}
      />
    </div>
  );
};
